<app-navbar class="dark:bg-slate-800"></app-navbar>

<div class="min-h-screen bg-gradient-to-br from-slate-50 via-purple-50/20 to-indigo-50/30 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 ml-auto lg:w-[75%] xl:w-[80%] 2xl:w-[85%]">
  
  <!-- Badge BETA - Solo en beta -->
  <div *ngIf="isBeta" class="fixed top-7 -left-5 z-50 lg:top-10 lg:-left-5">
    <div class="bg-gradient-to-r from-orange-500 to-red-500 text-white px-3 py-1 rounded-full shadow-lg transform -rotate-45 animate-pulse">
      <span class="font-mono text-xs font-bold tracking-wider">BETA {{version}}</span>
    </div>
  </div>
  
  <!-- Banner de advertencia - Solo en beta -->
  <div *ngIf="isBeta" class="mx-4 lg:mx-8 mt-4">
    <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-2xl p-4">
      <div class="flex items-center space-x-3">
        <span class="text-2xl">🧪</span>
        <p class="font-mono text-blue-800 dark:text-blue-200 font-medium">
          Función en desarrollo - Úsala con precaución
        </p>
      </div>
    </div>
  </div>

  <!-- Header Section -->
  <div class="px-4 lg:px-8 py-6 lg:py-8">
    <div class="max-w-7xl mx-auto">
      <div class="text-center mb-8">
        <h1 class="font-mono text-3xl lg:text-4xl font-bold text-gray-800 dark:text-gray-200 mb-3">
          Mis Pensamientos
        </h1>
        <p class="font-mono text-gray-600 dark:text-gray-400 text-lg">
          Explora tus reflexiones anteriores
        </p>
      </div>
    </div>
  </div>
  <!-- Relief Cards Grid -->
  <div class="px-4 lg:px-8 pb-8">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <div class="group" *ngFor="let relief of reliefs">
          <div class="h-full backdrop-blur-sm rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 overflow-hidden relative border-2"
               [ngClass]="{
                 'bg-teal-50 dark:bg-teal-900/20 border-teal-300 dark:border-teal-700': relief.feeling === 'Feliz',
                 'bg-green-50 dark:bg-green-900/20 border-green-300 dark:border-green-700': relief.feeling === 'Contento',
                 'bg-amber-50 dark:bg-amber-900/20 border-amber-300 dark:border-amber-700': relief.feeling === 'Serio',
                 'bg-orange-50 dark:bg-orange-900/20 border-orange-300 dark:border-orange-700': relief.feeling === 'Incomodo',
                 'bg-blue-50 dark:bg-blue-900/20 border-blue-300 dark:border-blue-700': relief.feeling === 'Triste',
                 'bg-red-50 dark:bg-red-900/20 border-red-300 dark:border-red-700': relief.feeling === 'Enojado',
                 'bg-white/60 dark:bg-slate-800/60 border-purple-100 dark:border-slate-700': !relief.feeling
               }">
            
            <!-- Header con fecha y acciones -->
            <div class="px-4 py-3 border-b"
                 [ngClass]="{
                   'border-teal-200/50 dark:border-teal-800/50': relief.feeling === 'Feliz',
                   'border-green-200/50 dark:border-green-800/50': relief.feeling === 'Contento',
                   'border-amber-200/50 dark:border-amber-800/50': relief.feeling === 'Serio',
                   'border-orange-200/50 dark:border-orange-800/50': relief.feeling === 'Incomodo',
                   'border-blue-200/50 dark:border-blue-800/50': relief.feeling === 'Triste',
                   'border-red-200/50 dark:border-red-800/50': relief.feeling === 'Enojado',
                   'border-purple-100/50 dark:border-slate-700/50': !relief.feeling
                 }">
              <div class="flex items-center justify-between">
                <!-- Auto-delete indicator -->
                <div class="flex items-center">
                  <div *ngIf="relief.deleteIn24h" class="w-5 h-5 text-orange-500" title="Auto-eliminar activado">
                    <svg class="w-full h-full" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"/>
                      <polyline points="12,6 12,12 16,14"/>
                    </svg>
                  </div>
                </div>
                
                <!-- Fecha -->
                <div class="flex-1 text-center">
                  <span class="text-xs font-mono px-2 py-1 rounded-full"
                        [ngClass]="{
                          'bg-teal-100 dark:bg-teal-900/40 text-teal-700 dark:text-teal-300': relief.feeling === 'Feliz',
                          'bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300': relief.feeling === 'Contento',
                          'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300': relief.feeling === 'Serio',
                          'bg-orange-100 dark:bg-orange-900/40 text-orange-700 dark:text-orange-300': relief.feeling === 'Incomodo',
                          'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300': relief.feeling === 'Triste',
                          'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300': relief.feeling === 'Enojado',
                          'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400': !relief.feeling
                        }">
                    {{relief.createdAt.toDate() | date: 'dd/MM/YY HH:mm'}}
                  </span>
                </div>
                
                <!-- Botón eliminar -->
                <button class="w-6 h-6 flex items-center justify-center text-red-500 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-full transition-colors" 
                        (click)="deleteThought(relief.id)"
                        title="Eliminar pensamiento">
                  <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c0 1 1 2 2 2v2"/>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Contenido principal -->
            <div class="px-4 py-6 relative">
              <!-- Decorative background element -->
              <div class="absolute top-2 right-2 w-16 h-16 rounded-full opacity-10"
                   [ngClass]="{
                     'bg-teal-500': relief.feeling === 'Feliz',
                     'bg-green-500': relief.feeling === 'Contento',
                     'bg-amber-500': relief.feeling === 'Serio',
                     'bg-orange-500': relief.feeling === 'Incomodo',
                     'bg-blue-500': relief.feeling === 'Triste',
                     'bg-red-500': relief.feeling === 'Enojado',
                     'bg-purple-500': !relief.feeling
                   }"></div>
              
              <!-- Decorative shapes for accessibility -->
              <!-- Feliz: Estrella -->
              <div *ngIf="relief.feeling === 'Feliz'" class="absolute bottom-3 left-3 w-5 h-5 opacity-10">
                <svg class="w-full h-full text-teal-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                </svg>
              </div>
              
              <!-- Contento: Corazón -->
              <div *ngIf="relief.feeling === 'Contento'" class="absolute bottom-3 left-3 w-5 h-5 opacity-10">
                <svg class="w-full h-full text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"/>
                </svg>
              </div>
              
              <!-- Serio: Cuadrado -->
              <div *ngIf="relief.feeling === 'Serio'" class="absolute bottom-3 left-3 w-5 h-5 opacity-10 bg-amber-500"></div>
              
              <!-- Incómodo: Triángulo -->
              <div *ngIf="relief.feeling === 'Incomodo'" class="absolute bottom-3 left-3 w-5 h-5 opacity-10">
                <svg class="w-full h-full text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 3L3 17h14L10 3z" clip-rule="evenodd"/>
                </svg>
              </div>
              
              <!-- Triste: Gota/Lágrima -->
              <div *ngIf="relief.feeling === 'Triste'" class="absolute bottom-3 left-3 w-5 h-5 opacity-10">
                <svg class="w-full h-full text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 2C10 2 4 8 4 12c0 3.314 2.686 6 6 6s6-2.686 6-6c0-4-6-10-6-10z"/>
                </svg>
              </div>
              
              <!-- Enojado: Rayo/Zigzag -->
              <div *ngIf="relief.feeling === 'Enojado'" class="absolute bottom-3 left-3 w-5 h-5 opacity-10">
                <svg class="w-full h-full text-red-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M11 3L7 9h4l-1 8 4-6h-4l1-8z"/>
                </svg>
              </div>
              
              <!-- Sin sentimiento: Círculo (por defecto) -->
              <div *ngIf="!relief.feeling" class="absolute bottom-3 left-3 w-5 h-5 rounded-full opacity-10 bg-purple-500"></div>
              
              <!-- Imagen del sentimiento -->
              <div class="flex justify-center mb-4 relative z-10">
                <div class="w-24 h-24 flex items-center justify-center rounded-2xl p-2 transition-all duration-300"
                     [ngClass]="{
                       'bg-teal-50/50 dark:bg-teal-900/20': relief.feeling === 'Feliz',
                       'bg-green-50/50 dark:bg-green-900/20': relief.feeling === 'Contento',
                       'bg-amber-50/50 dark:bg-amber-900/20': relief.feeling === 'Serio',
                       'bg-orange-50/50 dark:bg-orange-900/20': relief.feeling === 'Incomodo',
                       'bg-blue-50/50 dark:bg-blue-900/20': relief.feeling === 'Triste',
                       'bg-red-50/50 dark:bg-red-900/20': relief.feeling === 'Enojado',
                       'bg-purple-50/50 dark:bg-purple-900/20': !relief.feeling
                     }">
                  <img class="w-full h-full object-contain drop-shadow-md filter transition-all duration-300 group-hover:scale-110" 
                       [src]="relief.feeling ? 'assets/'+relief.feeling+'.png': 'assets/logodr.png'" 
                       [alt]="relief.feeling || 'Daily Relief'">
                </div>
              </div>
              
              <!-- Nombre del sentimiento -->
              <div class="text-center mb-4">
                <span class="inline-block font-mono text-sm font-medium px-3 py-1 rounded-full"
                      [ngClass]="{
                        'bg-teal-200 dark:bg-teal-800/60 text-teal-800 dark:text-teal-200': relief.feeling === 'Feliz',
                        'bg-green-200 dark:bg-green-800/60 text-green-800 dark:text-green-200': relief.feeling === 'Contento',
                        'bg-amber-100 dark:bg-amber-800/60 text-amber-800 dark:text-amber-200': relief.feeling === 'Serio',
                        'bg-orange-200 dark:bg-orange-800/60 text-orange-800 dark:text-orange-200': relief.feeling === 'Incomodo',
                        'bg-blue-200 dark:bg-blue-800/60 text-blue-800 dark:text-blue-200': relief.feeling === 'Triste',
                        'bg-red-200 dark:bg-red-800/60 text-red-800 dark:text-red-200': relief.feeling === 'Enojado',
                        'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200': !relief.feeling
                      }">
                  {{ relief.feeling || 'Pensamiento' }}
                </span>
              </div>
              
              <!-- Botón ver contenido -->
              <div class="flex justify-center">
                <button (click)="decrypt(relief.relief,relief.userId, relief.feeling)" 
                        class="flex items-center space-x-2 text-white px-4 py-2 rounded-xl font-mono text-sm font-medium transition-all duration-200 shadow-md hover:shadow-lg hover:scale-105"
                        [ngClass]="{
                          'bg-teal-500 hover:bg-teal-600': relief.feeling === 'Feliz',
                          'bg-green-500 hover:bg-green-600': relief.feeling === 'Contento',
                          'bg-amber-500 hover:bg-amber-600': relief.feeling === 'Serio',
                          'bg-orange-500 hover:bg-orange-600': relief.feeling === 'Incomodo',
                          'bg-blue-500 hover:bg-blue-600': relief.feeling === 'Triste',
                          'bg-red-500 hover:bg-red-600': relief.feeling === 'Enojado',
                          'bg-purple-500 hover:bg-purple-600': !relief.feeling
                        }">
                  <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  <span>Ver contenido</span>
                </button>
              </div>
            </div>

            <!-- Info de auto-eliminación -->
            <div *ngIf="relief.deleteIn24h && relief.deleteAt" class="px-4 pb-4">
              <div class="text-center">
                <div class="inline-flex items-center bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 text-xs font-mono px-3 py-2 rounded-xl border border-orange-200 dark:border-orange-800">
                  <svg class="w-3 h-3 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                    <line x1="12" y1="9" x2="12" y2="13"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                  Se elimina: {{ relief.deleteAt.toDate() | date: 'dd/MM/YY HH:mm' }}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Modal de contenido -->
<div *ngIf="isModalVisible" class="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50 p-4" (click)="closeModal()">
  <div class="bg-white/95 dark:bg-slate-800/95 backdrop-blur-lg rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col border border-purple-100 dark:border-slate-700" (click)="$event.stopPropagation()">
    
    <!-- Header -->
    <div class="flex-shrink-0 px-6 py-4 border-b border-purple-100 dark:border-slate-700">
      <div class="flex justify-between items-center">
        <div class="flex items-center space-x-3">
          <div class="w-8 h-8 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-lg flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <h2 class="font-mono text-xl font-bold text-gray-800 dark:text-gray-200 capitalize">{{ modalFeeling }}</h2>
        </div>
        <button (click)="closeModal()" class="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
    </div>
    
    <!-- Contenido -->
    <div class="flex-1 overflow-y-auto px-6 py-6">
      <div class="font-mono text-gray-700 dark:text-gray-300 text-base leading-relaxed whitespace-pre-wrap bg-gray-50/50 dark:bg-slate-700/50 rounded-xl p-4 border border-gray-200 dark:border-slate-600">
        {{ modalData }}
      </div>
    </div>
    
    <!-- Footer -->
    <div class="flex-shrink-0 px-6 py-4 border-t border-purple-100 dark:border-slate-700">
      <button (click)="closeModal()" class="w-full py-3 px-4 bg-gradient-to-r from-purple-500 to-indigo-600 hover:from-purple-600 hover:to-indigo-700 text-white rounded-xl font-mono font-medium transition-all duration-200 hover:shadow-lg">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal de confirmación de eliminación -->
<div *ngIf="showDeleteModal" class="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50 p-4">
  <div class="bg-white/95 dark:bg-slate-800/95 backdrop-blur-lg rounded-2xl shadow-2xl p-6 w-full max-w-md border border-red-200 dark:border-red-800">
    <div class="text-center">
      <div class="w-16 h-16 bg-gradient-to-r from-red-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
        </svg>
      </div>
      <h2 class="font-mono text-xl font-bold text-gray-800 dark:text-gray-200 mb-2">¿Eliminar pensamiento?</h2>
      <p class="font-mono text-gray-600 dark:text-gray-400 mb-6">Esta acción no se puede deshacer.</p>
      <div class="flex gap-3">
        <button (click)="cancelDelete()" class="flex-1 py-3 px-4 bg-gray-200 hover:bg-gray-300 dark:bg-slate-700 dark:hover:bg-slate-600 text-gray-800 dark:text-gray-200 rounded-xl font-mono font-medium transition-colors">
          Cancelar
        </button>
        <button (click)="confirmDelete()" class="flex-1 py-3 px-4 bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white rounded-xl font-mono font-medium transition-all duration-200 hover:shadow-lg">
          Eliminar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Loading Toast -->
<div *ngIf="isLoading" class="fixed bottom-8 right-8 z-50 pointer-events-none">
  <div class="bg-white/95 dark:bg-slate-800/95 backdrop-blur-lg rounded-2xl shadow-2xl border border-purple-100 dark:border-slate-700 p-4">
    <div class="flex items-center space-x-3">
      <div class="w-8 h-8 relative">
        <div class="w-full h-full border-3 border-purple-200 dark:border-purple-800 rounded-full"></div>
        <div class="absolute top-0 left-0 w-full h-full border-3 border-purple-500 rounded-full border-r-transparent animate-spin"></div>
      </div>
      <span class="font-mono text-gray-700 dark:text-gray-300 font-medium">Eliminando...</span>
    </div>
  </div>
</div>

<!-- Success Toast -->
<div *ngIf="showSuccess" class="fixed bottom-8 right-8 z-50 pointer-events-none">
  <div class="bg-white/95 dark:bg-slate-800/95 backdrop-blur-lg rounded-2xl shadow-2xl border border-green-200 dark:border-green-800 p-4">
    <div class="flex items-center space-x-3">
      <div class="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center">
        <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
        </svg>
      </div>
      <span class="font-mono text-gray-700 dark:text-gray-300 font-medium">¡Pensamiento eliminado!</span>
    </div>
  </div>
</div>